import React from 'react';
import { Search, Bell, Settings } from 'lucide-react';
import { useUser } from '../../context/UserContext';

const PartnerNavbar = () => {
  const { user } = useUser();

  return (
    <header className="partner-header shadow-sm border-0">
      <div className="d-flex align-items-center">
        <div>
          <h5 className="mb-0 fw-bold" style={{ color: 'var(--partner-text-primary)' }}>Paudhawala Analytics</h5>
          <small className="text-muted">Read-Only Biological Intelligence Panel</small>
        </div>
      </div>

      <div className="d-flex align-items-center gap-3">
        {/* Search */}
        <div className="position-relative d-none d-md-flex" style={{ width: '250px' }}>
          <Search size={16} className="position-absolute text-muted" style={{ top: '10px', left: '12px' }} />
          <input 
            type="text" 
            className="form-control bg-light border-0" 
            placeholder="Search Metrics..." 
            style={{ paddingLeft: '36px', fontSize: '0.85rem' }} 
            disabled
          />
        </div>

        {/* Icons */}
        <button className="btn-icon bg-transparent border-0 text-muted p-2">
          <Bell size={18} />
        </button>
        
        <button className="btn-icon bg-transparent border-0 text-muted p-2">
          <Settings size={18} />
        </button>

        {/* Profile indicator */}
        <div className="ms-2 d-flex align-items-center gap-2">
          <div className="text-end d-none d-lg-block">
            <div className="fw-bold text-dark" style={{ fontSize: '0.85rem' }}>{user?.username || 'Partner Analyst'}</div>
            <div className="text-muted" style={{ fontSize: '0.7rem' }}>Global Observer</div>
          </div>
          <div className="rounded-circle bg-success text-white d-flex align-items-center justify-content-center fw-bold" style={{ width: '36px', height: '36px' }}>
            {user?.username?.charAt(0).toUpperCase() || 'P'}
          </div>
        </div>
      </div>
    </header>
  );
};

export default PartnerNavbar;
